import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  chooseAddressDescription: {
    description:
      'explains that the address entered may have errors and that they can choose to use the entered address or the suggested address',
    defaultMessage:
      "Would you like to use the suggested address from the address verification database? Please select which address you'd like to use, or edit your entered address, if incorrect.",
    id: 'PYhrRj',
  },
  verifyYourAddress: {
    description: 'header for modal for selecting either the address entered or a suggested address',
    defaultMessage: 'Verify Your Address',
    id: '4cd879',
  },
  enteredAddress: {
    description: 'radio button label to select entered address',
    defaultMessage: 'Entered Address',
    id: 'o8emaz',
  },
  suggestedAddress: {
    description: 'radio button label to select suggested address',
    defaultMessage: 'Suggested Address',
    id: 'Bfz7Ca',
  },
  editAddress: {
    description: 'button text that closes the modal and returns the user to the edit form',
    defaultMessage: 'Edit Address',
    id: 'FodQGx',
  },
  cancel: {
    description: 'button text that closes the modal and returns the user to the edit form',
    defaultMessage: 'Cancel',
    id: 'pZbdoK',
  },
  saveAddress: {
    description: 'button text that saves the address and advanced to the next wizrad screen',
    defaultMessage: 'Save Address',
    id: 'RoYu6s',
  },
  errorDescription: {
    description:
      'explains that the address entered may have errors and that they can choose to use the entered address or the suggested address',
    defaultMessage:
      "We've detected a potentially incorrect address, which may prevent successful registration. Please review the address to ensure it's accurate before you proceed.",
    id: 'sSp+II',
  },
  errorConfirmationQuestion: {
    description: 'confirms the user wants to continue with unvalidated address',
    defaultMessage: 'Do you want to continue with the address as is?',
    id: '277Bb/',
  },
});
